import api from './api';

/**
 * Öffentlicher Service für Informationsseiten (/info, /info/<slug>).
 */

export interface InfoPageSection {
  heading?: string | null;
  body?: string | null;
  order?: number | null;
}

export interface InfoPageFaq {
  question?: string | null;
  answer?: string | null;
  order?: number | null;
}

export interface InfoPageKeyFact {
  icon?: string | null;
  label?: string | null;
  value?: string | null;
  sublabel?: string | null;
  order?: number | null;
}

export interface InfoPage {
  _id?: string | null;
  id?: string | null;
  slug?: string | null;
  title?: string | null;
  category?: string | null;
  intro?: string | null;
  sections?: InfoPageSection[] | null;
  faq?: InfoPageFaq[] | null;
  keyFacts?: InfoPageKeyFact[] | null;
  thumbnail?: string | null;
  heroImage?: string | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  seoKeywords?: string[] | null;
  tags?: string[] | null;
  views?: number | null;
  updatedAt?: number | null;
  createdAt?: number | null;
}

class InfoPageService {
  async getAllPages(): Promise<InfoPage[]> {
    const res = await api.get('/api/info-pages');
    return (res.data?.pages as InfoPage[]) ?? [];
  }

  async getPageBySlug(slug: string): Promise<InfoPage | null> {
    try {
      const res = await api.get(`/api/info-page/slug/${encodeURIComponent(slug)}`);
      return (res.data as InfoPage) || null;
    } catch {
      return null;
    }
  }

  buildFileUrl(path?: string | null): string | null {
    if (!path) return null;
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    const base = api.defaults.baseURL || '';
    if (path.startsWith('/')) return `${base}${path}`;
    return `${base}/api/file/${path}`;
  }
}

const infoPageService = new InfoPageService();
export default infoPageService;
